import { AuthApiService } from '@revenuewell/logic-http';
import { NavigationService } from '@revenuewell/logic-navigation';
import { OidcService } from '@revenuewell/logic-oidc';
import LocationService, { ILocation } from '../location-service/location-service';
import { IPNKeys } from '../pubnub-service';

export interface IMailboxWithLocation {
    id: number;
    locationId: number;
    customerUserId: number;
    pubnubPrefix: string;
    location: ILocation;
}
export default class MailboxService extends AuthApiService {
    private static instance: MailboxService;
    private config: any;
    private locationService: LocationService;
    private configUrl: string;

    private constructor(config: any, oidcService: OidcService) {
        super(oidcService, new NavigationService());
        this.config = config;
        this.locationService = LocationService.getInstance(config, oidcService);
        this.configUrl = this.config.config.apiUrl;
        return this;
    }

    public static getInstance(config: any, oidcService: OidcService) {
        if (!MailboxService.instance) MailboxService.instance = new MailboxService(config, oidcService);

        return MailboxService.instance;
    }

    public async getPubnubCredentials(mailboxIds: number[]): Promise<IPNKeys> {
        const { masterAccountId } = await this.oidcService.getClaims();
        const url = `${this.configUrl}/master-accounts/${masterAccountId}/mailbox-auth`;

        const response = await this.authFetch(url, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                mailboxes: mailboxIds
            })
        });
        const data: IPNKeys = await response.json();

        return data;
    }

    public async getMailboxes(): Promise<IMailboxWithLocation[]> {
        const { masterAccountId } = await this.oidcService.getClaims();
        const url = `${this.configUrl}/master-accounts/${masterAccountId}/mailboxes`;

        if (!masterAccountId) {
            console.error('Mailbox Service - masterAccountId is required.');
            return [];
        }

        const response = await this.authFetch(url, { method: 'GET' }, { ttlSeconds: 60 });
        const mailboxes = await response.json();

        const locations = await this.locationService.getAvailableLocations(masterAccountId);
        const data: IMailboxWithLocation[] = mailboxes.map((mailbox: IMailboxWithLocation) => ({
            ...mailbox,
            location: locations.find((location: ILocation) => location.id == mailbox.locationId)
        }));

        return data;
    }
}
